import React, { useState, useEffect } from 'react';
import StrengthsRadarChart from '../reusableElementsComponents/StrengthsRadarChart';
import RadarChartInfo from '../talentsComponents/RadarChartInfo';
import { t, lookups } from '../../content';
import { useLocale } from '../../locale';
import * as Constants from '../../constants';

const SalesStrengthsSection = ({ data }) => {
    const { locale } = useLocale();
    const [salesChartData, setSalesChartData] = useState({
        labels: lookups.salesStrengthLabels,
        datasets: [
            {
                label: t('talents.charts.competence'),
                backgroundColor: "rgba(179,181,198,0.2)",
                borderColor: "rgba(179,181,198,1)",
                pointBackgroundColor: "rgba(179,181,198,1)",
                pointHoverBorderColor: "rgba(179,181,198,1)",
                data: data.sales_strengths.competence,
            },
            {
                label: t('talents.charts.attitude'),
                backgroundColor: "rgba(255,99,132,0.2)",
                borderColor: "rgba(255,99,132,1)",
                pointBackgroundColor: "rgba(255,99,132,1)",
                pointHoverBorderColor: "rgba(255,99,132,1)",
                data: data.sales_strengths.attitude,
            },
        ],
    });

    useEffect(() => {
        setSalesChartData({
            labels: lookups.salesStrengthLabels,
            datasets: [
                {
                    label: t('talents.charts.competence'),
                    backgroundColor: "rgba(179,181,198,0.2)",
                    borderColor: "rgba(179,181,198,1)",
                    pointBackgroundColor: "rgba(179,181,198,1)",
                    pointHoverBorderColor: "rgba(179,181,198,1)",
                    data: data.sales_strengths.competence,
                },
                {
                    label: t('talents.charts.attitude'),
                    backgroundColor: "rgba(255,99,132,0.2)",
                    borderColor: "rgba(255,99,132,1)",
                    pointBackgroundColor: "rgba(255,99,132,1)",
                    pointHoverBorderColor: "rgba(255,99,132,1)",
                    data: data.sales_strengths.attitude,
                },
            ],
        });
    }, [data.sales_strengths, locale]);

    const lightOptionsSales = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: "#495057",
                },
                position: "bottom",
            },
        },
        scales: {
            r: {
                max: 5,
                min: 0,
                stepSize: 1,
                ticks: {
                    stepSize: 1,
                },
                pointLabels: {
                    fontSize: 14,
                    color: "#495057",
                    padding: 0,
                    margin: 0,
                },
                grid: {
                    color: "#ebedef",
                },
                angleLines: {
                    color: "#ebedef",
                },
            },
        },
    };

    return (
        <div className="row chart-with-info-section">
            <div className="col-6 vertical-divider">
                <div className="talent-details-strengths-charts">
                    <StrengthsRadarChart
                        title={t('talents.charts.salesStrengths')}
                        data={salesChartData}
                        options={lightOptionsSales}
                    />
                </div>
            </div>

            <div className="col-6">
                <div className="motivation" id="boxStyleMot">
                    <RadarChartInfo
                        title={t('talents.charts.salesStrengthsInfo')}
                        tabActiveKey={Constants.TAB_SALES_STRENGTHS_KEY}
                    />
                </div>
            </div>
        </div>
    );
};

export default SalesStrengthsSection;
